import React from "react";
import FormHelperText from "./FormHelperText";
import FormSubtext from "./FormSubtext";

const Radio = ({
  id,
  classes,
  error,
  label,
  name,
  placeholder,
  register,
  ...inputProps
}) => (
  <>
    <label htmlFor={id ?? name}>
      <input
        type="radio"
        value={inputProps.value}
        {...register(name)}
        className={`input-radio ${classes ?? ""}`}
        id={id ?? name}
        aria-label={label}
      />
      <span className="ml-2">{label}</span>
    </label>
    {inputProps.subtext && <FormSubtext text={inputProps.subtext} />}
    {error && <FormHelperText message={error.message} />}
  </>
);

export default Radio;
